import { EmptyText } from "@/components/styling/empty";
import styled from "@emotion/styled";
import uploadEmptyDropzone from "@/assets/images/upload-empty-drop.svg";
import uploadDropzone from "@/assets/images/upload-dropzone.svg";
import { mdsColors } from "@/design-system/foundations";
import { css } from "@/domains/emotion";

interface Props {
  isActive: boolean;
}

export const ImportDropTarget = ({ isActive }: Props) => (
  <Wrapper data-test-id="import-dropzone-ui">
    <img
      src={isActive ? uploadDropzone : uploadEmptyDropzone}
      alt="drag and drop notes here"
      width="71px"
      height="84px"
    />
    <HeroText isActive={isActive}>Drag and drop notes into your Mem</HeroText>
    <EmptyText
      className={css({
        color: isActive ? mdsColors().mblue.x500 : undefined,
        transition: "color 0.15s",
        margin: 0,
      })}
    >
      Supported file types: Text (.txt), Markdown (.md)
    </EmptyText>
  </Wrapper>
);

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
`;

const HeroText = styled.h1<{ isActive: boolean }>`
  font-size: ${({ theme }) => theme.fontSizes.large};
  font-weight: ${({ theme }) => theme.fontWeights.semiBold};
  color: ${({ theme, isActive }) => (isActive ? theme.colors.mblue.x500 : theme.colors.grey.x700)};
  text-align: center;
  margin: 0px;
  transition: color 0.15s;
`;
